import { GET_ALL_REDFLAGGED, GET_ALL_REDFLAG_RESOLVED, GET_REDFLAG_FLAGGEDBY, GET_REDFLAG_RESOLVEDBY } from './types'

const initialState = {
  redFlagged: [],
  redFlagResolved: [],
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_ALL_REDFLAGGED:
      return {
        ...state,
        redFlagged: action.payload,
      }
    case GET_ALL_REDFLAG_RESOLVED:
      return {
        ...state,
        redFlagResolved: action.payload,
      }
    case GET_REDFLAG_FLAGGEDBY:
      return {
        ...state,
        flaggedBy: action.payload,
      }
    case GET_REDFLAG_RESOLVEDBY:
      return {
        ...state,
        resolvedBy: action.payload,
      }
    default:
      return state
  }
}
